
<template>
  <div>
    <div style="min-height: 400px;">
      <v-chart
        :forceFit="true"
        height="400"
        :data="data"
        :scale="scale"
      >
        <v-tooltip />
        <v-axis
          :dataKey="axis1Opts.dataKey"
          :line="axis1Opts.line"
          :tickLine="axis1Opts.tickLine"
          :grid="axis1Opts.grid"
        />
        <v-axis
          :dataKey="axis2Opts.dataKey"
          :line="axis2Opts.line"
          :tickLine="axis2Opts.tickLine"
          :grid="axis2Opts.grid"
        />
        <v-legend
          dataKey="user"
          marker="circle"
          :offset="30"
        />
        <v-coord
          type="polar"
          radius="0.8"
        />
        <v-line
          position="item*score"
          color="user"
          :size="2"
        />
        <v-point
          position="item*score"
          color="user"
          :size="4"
          shape="circle"
        />
      </v-chart>
    </div>
  </div>
</template>
<script>
import { getPersonal, getTeamAbility } from '@/api/datum/synTrain'
const DataSet = require('@antv/data-set')
export default {
  name: 'SingleAbilityForm',
  data () {
    return {
      data: [],
      axis1Opts: [],
      axis2Opts: [],
      sourceData: [
        { item: '听', 班级: 0, 个人: 0 },
        { item: '说', 班级: 0, 个人: 0 },
        { item: '读', 班级: 0, 个人: 0 },
        { item: '写', 班级: 0, 个人: 0 },
        { item: '译', 班级: 0, 个人: 0 }
      ],
      scale: [],
      personalData: [],
      teamData: []
    }
  },
  created () {
    this.handlePersonal()
    // this.handleInit()
    this.axis1Opts = {
      dataKey: 'item',
      line: null,
      tickLine: null,
      grid: {
        lineStyle: {
          lineDash: null
        },
        hideFirstLine: false
      }
    }
    this.axis2Opts = {
      dataKey: 'score',
      line: null,
      tickLine: null,
      grid: {
        type: 'polygon',
        lineStyle: {
          lineDash: null
        }
      }
    }
  },
  methods: {
    handleInit () {
      const dv = new DataSet.View().source(this.sourceData)
      dv.transform({
        type: 'fold',
        fields: ['个人', '班级'],
        key: 'user',
        value: 'score'
      })
      this.data = dv.rows
      this.scale = [{
        dataKey: 'score',
        min: 0,
        max: 20
      }]
      this.axis1Opts = {
        dataKey: 'item',
        line: null,
        tickLine: null,
        grid: {
          lineStyle: {
            lineDash: null
          },
          hideFirstLine: false
        }
      }
      this.axis2Opts = {
        dataKey: 'score',
        line: null,
        tickLine: null,
        grid: {
          type: 'polygon',
          lineStyle: {
            lineDash: null
          }
        }
      }
    },
    handlePersonal () {
      this.personalData = []
      this.teamData = []
      // 查询个人单项能力
      getPersonal().then(res => {
        this.personalData = res.result
        getTeamAbility().then(res => {
          this.teamData = res.result
          this.handleData()
        })
      }).catch(() => {
        this.$message.error('数据加载失败，请检查网络')
      })
    },
    handleData () {
      this.sourceData = []
      // console.log('个人：' + JSON.stringify(this.personalData))
      // console.log('班级：' + JSON.stringify(this.teamData))
      this.sourceData.push({
        item: '听',
        '班级': this.teamData[0].listening,
        '个人': this.personalData[0].listening
      })
      this.sourceData.push({
        item: '说',
        '班级': this.teamData[0].speaking,
        '个人': this.personalData[0].speaking
      })
      this.sourceData.push({
        item: '读',
        '班级': this.teamData[0].reading,
        '个人': this.personalData[0].reading
      })
      this.sourceData.push({
        item: '写',
        '班级': this.teamData[0].writing,
        '个人': this.personalData[0].writing
      })
      this.sourceData.push({
        item: '译',
        '班级': this.teamData[0].translating,
        '个人': this.personalData[0].translating
      })
      // console.log('this.sourceData：' + JSON.stringify(this.sourceData))
      this.handleInit()
    }
  }
}
</script>
